import React from 'react';
import { connect } from 'react-redux';

import { routes, url } from 'oo-routes';
import NavBar from '../../components/NavBar2';
import Footer from '../../components/Footer2';

import './styles';

const menuItems = [
  {
    name: 'Product Catalog',
    url: url('website', routes.website.catalog.base),
  },
  {
    name: 'API',
    url: url('website', routes.website2.home.api),
  },
  {
    name: 'Login',
    url: url('website', routes.website.auth.login),
  },
];

const loggedInMenuItems = [
  {
    name: 'Designs',
    url: url('manager', routes.manager.design.base),
  },
  {
    name: 'Orders',
    url: url('manager', routes.manager.order.base),
  },
  {
    name: 'Billing',
    url: url('manager', routes.manager.billing.base),
  },
  {
    name: 'Place Order',
    url: url('order2', routes.order2.cart.base),
  },
  {
    name: 'Settings',
    url: url('manager', routes.manager.settings.base),
  },
];

class Layout extends React.Component {
  render() {
    return (
      <div className="Layout">
        <NavBar
          user={this.props.user}
          landing={this.props.location.pathname === routes.website2.home.base}
          careers={this.props.location.pathname === routes.website2.home.careers.base || this.props.location.pathname === routes.website2.home.jobs}
        />
        {this.props.children}
        <Footer
          hideTestimonials={this.props.location.pathname === routes.website2.home.careers.base || this.props.location.pathname === routes.website2.home.jobs}
          user={this.props.user}
        />
      </div>
    );
  }
}

function select(state) {
  return {
    user: state.auth.user,
  };
}

export default connect(select)(Layout);



// WEBPACK FOOTER //
// ./app/pages/Layout/index.jsx